import { parseStrapiImage, parseStrapiResponse } from '@betterpool/strapi-client';

import { fetchStrapiJSON } from '../../fetchStrapiJSON';
import { StrapiCollection } from '../../enums/strapi.enum';

import type { TSlide, TGetSlideResponse, SlideFilter } from './types';

const parseResponse = (response: TGetSlideResponse): TSlide[] => {
  const parsedStrapiResponse = parseStrapiResponse(response);

  if (!parsedStrapiResponse) return [];

  const slides: TSlide[] = response.data.map((item) => {
    const attributes = item.attributes;

    return {
      id: attributes.id,
      title: attributes.title || '',
      copy: attributes.copy || '',
      imageIOS: parseStrapiImage(attributes.imageIOS?.data?.attributes),
      imageAndroid: parseStrapiImage(attributes.imageAndroid?.data?.attributes),
      imageDesktop: parseStrapiImage(attributes.imageDesktop?.data?.attributes),
    };
  });

  return slides;
};

const getSlides = (filter: SlideFilter) =>
  fetchStrapiJSON<TGetSlideResponse>(
    StrapiCollection.AUTH_SIGN_UP_SLIDESHOW,
    {
      populate: {
        imageIOS: '*',
        imageAndroid: '*',
        imageDesktop: '*',
      },
    },
    {
      $or: [{ platform: { $eq: 'all' } }, { platform: { $eq: filter.platform } }],
    }
  ).then((r) => parseResponse(r));

export default getSlides;
